import { render, staticRenderFns } from "./freeRecord.vue?vue&type=template&id=704ca110&scoped=true&"
import script from "./freeRecord.vue?vue&type=script&lang=js&"
export * from "./freeRecord.vue?vue&type=script&lang=js&"
import style0 from "./freeRecord.vue?vue&type=style&index=0&id=704ca110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ca110",
  null
  
)

export default component.exports